import { isDemoHostAllowed } from './isDemoHostAllowed';

// True only while the browser is inside a demo session: the entrypoint
// (/pay/demo/start) set the flag AND the host is one the demo may run on, so a
// flag left in localStorage cannot alter behaviour in production.
export function isDemoModeEnabled(): boolean {
  return (
    localStorage.getItem('demoModeEnabled') === 'true' && isDemoHostAllowed()
  );
}
